import type { User } from '@core/api/user';
import axiosInstance from '@core/utils/axiosInstance';

export interface AuthResponse {
  token: string;
  user: User;
}

export async function login(
  identifier: string,
  password: string
): Promise<AuthResponse> {
  const { data } = await axiosInstance.post<AuthResponse>('/auth/login', {
    identifier,
    password,
  });
  return data;
}

export async function logout(): Promise<void> {
  await axiosInstance.post('/auth/logout');
}

export async function getCurrentUser(): Promise<User> {
  const { data } = await axiosInstance.get<User>('/auth/me');
  return data;
}
